import { motion } from "framer-motion";
import { Github, ExternalLink, Mail } from "lucide-react";
import { CITY_URL, EMAIL } from "@/constants/assets";

export default function OpenSource() {
  return (
    <section className="py-24 sm:py-32 bg-gb-bg2 border-t-2 border-gb-line">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7 }}
          >
            <p className="text-gb-neon text-[11px] tracking-[0.3em] mb-3">10 · THE COMMITMENT</p>
            <h2 className="font-title text-6xl sm:text-7xl uppercase text-gb-pale leading-[0.85]">
              Open source,
              <br />
              <span className="text-gb-neon glow-text">soon.</span>
            </h2>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-gb-light/85">
              The kernel, the evaluation gates and the research tooling are
              being prepared for public release on GitHub. When it ships,
              you'll be able to replay, fork and audit the city yourself.
            </p>
            <div
              data-testid="opensource-github-badge"
              className="mt-7 inline-flex items-center gap-3 border-2 border-dashed border-gb-accent/50 text-gb-accent/70 text-xs tracking-[0.18em] px-6 py-4 cursor-not-allowed select-none"
            >
              <Github size={15} />
              GITHUB · COMING SOON
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:pt-16"
          >
            <h2 className="font-title text-6xl sm:text-7xl uppercase text-gb-pale leading-[0.85]">
              Research,
              <br />
              <span className="text-outline">permanent.</span>
            </h2>
            <p className="mt-6 max-w-md text-sm leading-relaxed text-gb-light/85">
              Every ledger, replay and release note is archived. The city runs
              today; the record survives it. What is written to the chain stays
              written.
            </p>
            <div className="mt-7 flex flex-wrap gap-4">
              <a
                data-testid="opensource-live-cta"
                href={CITY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="group inline-flex items-center gap-3 bg-gb-neon text-gb-bg font-bold text-xs tracking-[0.18em] px-6 py-4 shadow-[0_0_30px_rgba(64,240,112,0.3)] hover:shadow-[0_0_50px_rgba(64,240,112,0.55)] hover:-translate-y-0.5 transition-all duration-200"
              >
                INTERACT WITH THE CITY LIVE
                <ExternalLink size={14} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </a>
              <a
                data-testid="opensource-email-cta"
                href={`mailto:${EMAIL}`}
                className="inline-flex items-center gap-2 border-2 border-gb-accent/60 text-gb-pale text-xs tracking-[0.18em] px-6 py-4 hover:bg-gb-accent hover:text-gb-bg transition-all duration-200"
              >
                <Mail size={14} /> GET IN TOUCH
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
